<template>
  <div class="contact-support-wrapper py-5 mb-5">
    <div class="container">
      <div class="row">
        <div class="col pb-5">
          <title-with-bookmark :title="'Contact Support'" />
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-lg-6"
          v-for="(cardData, i) in contactSupportList"
          :key="i"
        >
          <div :class="getSpacingClass(i)">
            <contact-card :card-data="cardData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as CONSTANTS from '../../store/constants'
import ContactCard from "./ContactCard";
import TitleWithBookmark from "../TitleWithBookmark";
import LumiBanner from "./LumiBanner"

export default {
  name: "contact-support",
  components: {
    ContactCard,
    TitleWithBookmark,
    LumiBanner
  },
  created() {
    document.title = "Support - Autodesk One";
    this.initializeComponent();
  },
  data() {
    return {
      contactSupportList: CONSTANTS.CONTACT_SUPPORT_LIST
    };
  },
  watch: {
    // for impersonation, when user changes reinitialize component
    "user.userName": function () {
      this.initializeComponent();
    },
  },
  computed: {
    ...mapGetters(["standardContentAccessible", "user", "userCriteria"]),
  },
  methods: {
    ...mapActions(["fetchUserCriteria"]),

    async initializeComponent() {
      let contactSupportList = this.contactSupportList;

      // filter out support cards based on user authorities
      contactSupportList = this.filterByStandardContent(contactSupportList);
      this.contactSupportList = contactSupportList;
    },

    filterByStandardContent(contactSupportList) {
      let result = contactSupportList.filter((contact) => {
        return (!contact.isStandardContent) ? true : this.standardContentAccessible;
      });
      return result;
    },

    getSpacingClass(cardIndex) {
      let isEven = cardIndex % 2 === 0;
      return isEven ? "pr-lg-3" : "pl-lg-3";
    },
  },
};
</script>

<style scoped>
.contact-support-wrapper {
  color: #000000;
  background: #FFFFFF;
}
</style>